'use strict';

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _grid = require('@alicd/next/lib/grid');

var _grid2 = _interopRequireDefault(_grid);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _localeProvider = require('@alicd/next/lib/locale-provider');

var _localeProvider2 = _interopRequireDefault(_localeProvider);

var _InterDialog = require('./InterDialog');

var _InterDialog2 = _interopRequireDefault(_InterDialog);

var _index = require('./local/index.js');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = function noop() {};

var wrapper = function wrapper(fn, callback) {
    return function () {
        var res = void 0;
        if (typeof fn === 'function') {
            res = fn();
        }
        if (res && res.then) {
            res.then(function (result) {
                if (result !== false) {
                    callback();
                }
            });
        } else if (res !== false) {
            callback();
        }
    };
},
    feedbackMaps = {
    alert: 'prompt',
    confirm: 'help',
    warning: 'warning'
};

var Modal = function (_React$Component) {
    (0, _inherits3.default)(Modal, _React$Component);

    function Modal(props) {
        (0, _classCallCheck3.default)(this, Modal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).call(this, props));

        _this.state = {
            visible: false
        };
        _this.close = _this.close.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(Modal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({
                visible: true
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                onOk = _props.onOk,
                onCancel = _props.onCancel,
                afterClose = _props.afterClose,
                canCloseByMask = _props.canCloseByMask,
                disabledBackgroundBlur = _props.disabledBackgroundBlur,
                icon = _props.icon,
                className = _props.className,
                title = _props.title,
                type = _props.type,
                content = _props.content,
                locale = _props.locale,
                onClose = _props.onClose,
                needWrapper = _props.needWrapper,
                footer = _props.footer,
                others = (0, _objectWithoutProperties3.default)(_props, ['onOk', 'onCancel', 'afterClose', 'canCloseByMask', 'disabledBackgroundBlur', 'icon', 'className', 'title', 'type', 'content', 'locale', 'onClose', 'needWrapper', 'footer']);


            locale = locale || {
                ok: 'Ok',
                cancel: 'Cancel',
                delete: 'Delete'
            };
            var Ok = wrapper(onOk, this.close),
                Cancel = wrapper(onCancel, this.close),
                Close = wrapper(onClose, this.close);
            return _react2.default.createElement(
                _InterDialog2.default,
                (0, _extends3.default)({ onClose: Close,
                    header: false,
                    height: 'auto',
                    visible: this.state.visible,
                    className: className,
                    okText: locale.ok,
                    onRequestClose: function onRequestClose() {
                        canCloseByMask && _this2.setState({ visible: false });
                    },
                    cancelText: locale.cancel,
                    deleteText: locale.delete,
                    onOk: Ok,
                    disabledBackgroundBlur: disabledBackgroundBlur,
                    onCancel: type !== 'alert' ? Cancel : null
                }, others),
                _react2.default.createElement(
                    'div',
                    { className: 'inter-show-parent' },
                    title ? _react2.default.createElement(
                        'div',
                        { className: 'inter-show-title' },
                        title
                    ) : null,
                    icon !== false ? _react2.default.createElement(
                        _grid2.default.Row,
                        { type: 'no-padding' },
                        _react2.default.createElement(
                            _grid2.default.Col,
                            { fixedSpan: 1 },
                            icon ? icon : this.getIcon(type)
                        ),
                        _react2.default.createElement(
                            _grid2.default.Col,
                            null,
                            _react2.default.createElement(
                                'div',
                                { style: { paddingLeft: 8 } },
                                content
                            )
                        )
                    ) : content
                )
            );
        }
    }, {
        key: 'getIcon',
        value: function getIcon(type) {
            if (type === 'confirm') {
                return _react2.default.createElement('i', { className: 'inter-show-color-icon inter-show-confirm' });
            } else if (type === 'warning') {
                return _react2.default.createElement('i', { className: 'inter-show-color-icon inter-show-warning' });
            } else if (type === 'alert') {
                return _react2.default.createElement('i', { className: 'inter-show-color-icon inter-show-alert' });
            }
        }
    }, {
        key: 'close',
        value: function close() {
            if (this.state.visible) {
                this.setState({
                    visible: false
                });
            }
        }
    }]);
    return Modal;
}(_react2.default.Component);

Modal.propTypes = {
    needWrapper: _propTypes2.default.bool,
    canCloseByMask: _propTypes2.default.bool
};
Modal.defaultProps = {
    needWrapper: true,
    onOk: function onOk() {},
    canCloseByMask: false
};


var LocaleModal = (0, _localeProvider2.default)(Modal);
LocaleModal.LOCALE = _index2.default;

var render = function render(config) {
    var container = document.createElement('div');
    var unMount = function unMount() {
        if (config && config.afterClose && typeof config.afterClose === 'function') {
            config.afterClose();
        }
        _reactDom2.default.unmountComponentAtNode(container);
        container.parentNode.removeChild(container);
    };
    var instance = void 0;
    document.body.appendChild(container);
    _reactDom2.default.render(_react2.default.createElement(LocaleModal, (0, _extends3.default)({}, config, { afterClose: unMount })), container, function () {
        instance = this;
    });
    return {
        hide: function hide() {
            var inc = instance && instance.getInstance();
            inc && inc.close();
        }
    };
};

(0, _keys2.default)(feedbackMaps).forEach(function (method) {
    exports[method] = function (config) {
        config = config || {};
        config.type = method;
        return render(config);
    };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-inter-dialog@0.0.46@@alicd/crui-inter-dialog/lib/show.js
// module id = 645
// module chunks = 0